import type { ActionConfig, ActionRegistry } from "../actions.types";

/**
 * Get config from registry by slug.
 */
export function getConfig(
  registry: ActionRegistry,
  slug: string
): ActionConfig | undefined {
  return registry.find((c) => c.slug === slug);
}

